import React from "react";
export const HomeSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 22.5 17.5"
  >
    <path d="M22.5,8.9c0,0.1,0,0.2-0.1,0.3l-1,1.2c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1l-9.2-7.6c-0.1-0.1-0.2-0.1-0.3-0.1  S11,2.9,11,2.9l-9.2,7.6c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.3-0.1-0.4-0.2l-1-1.2C0,9.2,0,9,0,8.9c0-0.1,0.1-0.3,0.2-0.4l9.9-8.1  C10.3,0.2,10.9,0,11.2,0s0.9,0.2,1.2,0.4l3.5,2.9V0.5c0-0.3,0.2-0.5,0.5-0.5h2.2c0.3,0,0.5,0.2,0.5,0.5v5.4l3.3,2.7  C22.4,8.6,22.5,8.8,22.5,8.9z M11.3,4.4c0.1,0,0.2,0,0.3,0.1l7.2,5.9v6.4c0,0.3-0.3,0.6-0.6,0.6l-4.4,0c-0.3,0-0.6-0.3-0.6-0.6  c0,0,0,0,0,0v-3.7c0-0.3-0.3-0.6-0.6-0.6H10c-0.3,0-0.6,0.3-0.6,0.6v3.7c0,0.3-0.3,0.6-0.6,0.6l-4.4,0c-0.3,0-0.6-0.3-0.6-0.6v-6.4  L11,4.5C11,4.5,11.2,4.4,11.3,4.4z" />
  </svg>
);
export const ManageUser = () => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 235.2 235.4"
  >
    <path d="M0,187.7c0.2-0.9,0.4-1.8,0.6-2.7c0.6-2.5,1.6-4.7,3.1-6.8c19.6-28.2,39.1-56.4,58.7-84.6c0.5-0.7,0.6-1.3,0.2-2.1  c-4.2-9-7.5-18.4-8.7-28.3C52.1,49.7,55.7,37.7,64,27c7.4-9.6,17-16.2,28-20.9c6.7-2.8,13.6-4.7,20.8-5.6  c11.6-1.4,22.7,0.3,33.1,5.5c19.3,9.6,30.7,25.3,34.1,46.6c2,12.7,1.2,25.2-2.9,37.4c-1,3-1,3-4.2,3c-22,0.3-40.9,8-56.4,23.7  c-2.5,2.5-5,5.2-7,8.2c-5,7.3-9.8,14.8-14.7,22.3c-4.5,6.9-8.8,13.8-13.2,20.7c-0.7,1.1-1.4,1.5-2.8,1.4c-6-0.5-12-1-17.9-1.5  c-0.9-0.1-1.4,0.2-1.8,0.9c-7.6,11.9-15.2,23.8-22.8,35.7c-2.3,3.5-5.4,5.9-9.3,7.3c-0.9,0.3-1.9,0.5-2.9,0.5  c-6,0-11.9-0.2-17.9-0.2c-1,0-1.5-0.4-1.8-1.2c-1-3.4-2-6.8-2.8-10.3c-0.7-2.9-1.1-5.9-1.7-8.9C0,190.3,0,189,0,187.7z M127.1,22.1  c-1.9,0.2-3.9,0.3-5.8,0.7c-8.8,1.9-15.4,6.8-19.6,14.8c-2.4,4.6-1.8,8.9,1.7,12.7c1.6,1.8,3.5,3.4,5.4,4.9c6,4.4,12,8.6,18.1,12.9  c2.3,1.6,4.7,3.2,7.2,4.5c1.8,0.9,3.9,1.5,5.9,1.7c3.7,0.4,6.5-1.6,8.8-4.3c6.1-7.3,8.1-15.6,6.2-24.9  C152.4,32,140.3,22.1,127.1,22.1z M71,102.9c-0.3,0.4-0.5,0.6-0.7,0.9c-18.8,27.3-37.5,54.5-56.3,81.8c-0.8,1.2-0.7,2.5-0.8,4  c1.5-0.6,2.8-1.1,3.8-2.4c17.6-24.9,35.3-49.8,52.9-74.6c1.5-2.1,3-4.2,4.5-6.4C73.2,105,72.1,103.9,71,102.9z M235.2,176  c-0.3,2.3-0.5,4.6-0.9,6.9c-4,21.1-15.5,36.7-34.6,46.1c-36.9,18.2-81.1-3.8-89.4-44.1c-6.6-32.2,12.8-64.3,44.4-73.3  c35.4-10.2,72,12,79.3,48c0.5,2.5,0.7,5.1,1.1,7.7c0,0.4,0.1,0.7,0.2,1C235.2,170.8,235.2,173.4,235.2,176z M173.6,209.8  c4.6-0.2,9.2-0.4,13.8-0.7c2.2-0.2,4.4-0.5,6.6-0.9c3.8-0.7,7.6-1.6,10.9-3.8c1.6-1.1,3-2.4,3.4-4.3c0.8-3.8,0.6-7.5-2.4-10.5  c-0.8-0.8-1.7-1.7-2.6-2.5c-5.2-4.2-11.2-6.8-17.4-9c-3.4-1.2-4.6-5.9-2.2-8.7c5.2-5.9,8.2-12.8,8.6-20.6c0.7-11.9-6-20.3-16.7-21.4  c-9.9-1-19.4,4.6-20.8,16.5c-1.1,9.7,2.1,18.2,8.4,25.5c0.4,0.4,0.7,1,0.9,1.5c1,3.4-0.3,5.8-3.6,7.1c-5,1.9-9.7,4.1-14.1,7  c-2.6,1.8-5.1,3.7-6.8,6.4c-2.9,4.7-1.6,10.7,3.2,13.2c2.4,1.3,5.1,2.3,7.8,2.9C158.2,209.4,165.9,209.6,173.6,209.8z" />
  </svg>
);
export const ManageCompany = () => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    width="1em"
    height="1em"
    fill="currentColor"
    y="0px"
    viewBox="0 0 23 21.5"
  >
    <path d="M22.9,9.3c-0.2-1.2-1.4-2-2.5-1.5c-0.4,0.2-0.9-0.1-1.1-0.5c-0.2-0.5-0.5-1-0.9-1.5c-0.3-0.4-0.2-0.9,0.1-1.2  c0.4-0.4,0.7-0.9,0.7-1.5c0-0.6-0.3-1.1-0.8-1.5C17.7,1,16.8,0.5,16,0.2C15.7,0.1,15.5,0,15.2,0c-0.9,0-1.7,0.7-1.9,1.6  c-0.1,0.5-0.5,0.8-1,0.7c-0.6-0.1-1.1-0.1-1.7,0c-0.5,0-0.9-0.3-1-0.7C9.5,0.7,8.7,0,7.8,0C7.5,0,7.3,0.1,7,0.2  C6.2,0.5,5.3,1,4.6,1.6C4.1,1.9,3.8,2.5,3.8,3.1c0,0.6,0.2,1.1,0.7,1.5c0.4,0.3,0.4,0.8,0.1,1.2C4.3,6.2,4,6.7,3.8,7.3  C3.6,7.7,3.1,7.9,2.6,7.8C2.4,7.7,2.2,7.6,2,7.6C1,7.6,0.2,8.4,0.1,9.3C0,9.8,0,10.3,0,10.7s0,1,0.1,1.4c0.2,1.2,1.4,2,2.5,1.5  c0.4-0.2,0.9,0.1,1.1,0.5c0.2,0.5,0.5,1,0.9,1.5c0.3,0.4,0.2,0.9-0.1,1.2c-0.4,0.4-0.7,0.9-0.7,1.5c0,0.6,0.3,1.1,0.8,1.5  C5.3,20.5,6.2,21,7,21.3c0.2,0.1,0.5,0.2,0.7,0.2c0.9,0,1.7-0.7,1.9-1.6c0.1-0.5,0.5-0.8,1-0.7c0.6,0.1,1.1,0.1,1.7,0  c0.5,0,0.9,0.3,1,0.7c0.2,0.9,0.9,1.6,1.9,1.6c0,0,0,0,0,0c0.3,0,0.5-0.1,0.7-0.2c0.9-0.4,1.7-0.9,2.5-1.4c0.5-0.4,0.7-0.9,0.8-1.5  c0-0.6-0.2-1.1-0.7-1.5c-0.4-0.3-0.4-0.8-0.1-1.2c0.3-0.5,0.6-1,0.9-1.5c0.2-0.4,0.7-0.7,1.1-0.5c0.2,0.1,0.4,0.1,0.7,0.1  c0.9,0,1.7-0.7,1.9-1.7c0.1-0.5,0.1-1,0.1-1.4S23,9.8,22.9,9.3z M11.5,17.2c-3.6,0-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5S18,7.2,18,10.7  S15.1,17.2,11.5,17.2z M7.2,14.2C6.5,13.2,6,12,6,10.7c0-3,2.5-5.5,5.5-5.5S17,7.7,17,10.7c0,1.3-0.5,2.5-1.2,3.4  c-0.5-1-1.5-2-2.7-2.5c0.5-0.5,0.9-1.1,0.9-1.9c0-1.4-1.1-2.5-2.5-2.5S9,8.4,9,9.7c0,0.8,0.3,1.4,0.9,1.9  C8.7,12.2,7.7,13.2,7.2,14.2z M15.1,14.9c-1,0.8-2.2,1.3-3.6,1.3c-1.4,0-2.6-0.5-3.5-1.3c0,0,0,0,0,0c0.4-1.2,2.1-2.7,3.5-2.7  S14.6,13.7,15.1,14.9C15,14.9,15,14.9,15.1,14.9z M11.5,8.2c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5S10,10.6,10,9.7  S10.7,8.2,11.5,8.2z" />
  </svg>
);
export const Travevelers = () => (
  <svg
    version="1.1"
    id="Layer_1"
    y="0px"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 83.1 54.9"
  >
    <path
      d="M38.3,14.4L18.5,4.2l8.6-3.7L49.8,9L38.3,14.4z M80.8,1.7c-6.7-3.5-12.8-0.5-12.8-0.5L19.7,24.2L4.5,19.3L0,21.7l17,16.1
                    L45,27.1l-3.6,27.8l8.5-3.5l12-32.5C78.5,11.9,87.5,5.2,80.8,1.7z"
    />
  </svg>
);
export const Products = () => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 86.8 94.9"
  >
    <path d="M84.9,23.6H1.8l18-22.3C20.5,0.5,21.5,0,22.6,0h41.6c1.1,0,2.1,0.4,2.8,1.3L84.9,23.6z M86.8,30.8v36.9c0,2-1.6,3.6-3.6,3.6  H70.4c-1.8,13.3-13.2,23.6-27,23.6s-25.2-10.3-27-23.6H3.6c-2,0-3.6-1.6-3.6-3.6V30.8H86.8z M63.4,67.8c0-11-9-20-20-20s-20,9-20,20  s9,20,20,20S63.4,78.8,63.4,67.8z M48.8,59.8l-7.9,9l-3.7-3.7c-1.4-1.4-3.7-1.4-5.1,0c-1.4,1.4-1.4,3.7,0,5.1l6.4,6.4  c0.7,0.7,1.6,1.1,2.6,1.1h0.1c1,0,1.9-0.5,2.6-1.2l10.5-11.9c1.3-1.5,1.2-3.8-0.3-5.1C52.4,58.1,50.1,58.3,48.8,59.8z" />
  </svg>
);

export const Pricing = () => (
  <svg
    version="1.1"
    width="1em"
    height="1em"
    fill="currentColor"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 133.3 133.3"
  >
    <path d="M133.2,55l-11-41.3c-0.3-1.3-1.3-2.3-2.6-2.6l-41.3-11c-1.3-0.3-2.6,0-3.6,1L1.1,74.7c-1.4,1.4-1.4,3.8,0,5.2l52.3,52.3  c1.4,1.4,3.8,1.4,5.2,0l73.6-73.7C133.2,57.7,133.5,56.3,133.2,55z M35.1,72.1c1.4-1.4,3.8-1.4,5.2,0L61.2,93c1.4,1.4,1.4,3.8,0,5.2  c-1.4,1.4-3.8,1.4-5.2,0L35.1,77.4c-1.5-1.4-1.7-3.7-0.3-5.1C34.9,72.2,34.9,72.1,35.1,72.1z M74.3,85.2c-1.4,1.4-3.8,1.4-5.2,0  L48.1,64.3c-1.4-1.4-1.4-3.8,0-5.2s3.8-1.4,5.2,0L74.3,80C75.7,81.4,75.8,83.7,74.3,85.2C74.3,85.2,74.3,85.2,74.3,85.2z M83.4,32.9  c4.7-4.7,12.3-4.7,17,0c4.7,4.7,4.7,12.3,0,17c-4.7,4.7-12.3,4.7-17,0l0,0C78.7,45.2,78.8,37.6,83.4,32.9L83.4,32.9z" />
  </svg>
);
export const Orders = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="1em"
    height="1em"
    fill="currentColor"
    x="0px"
    y="0px"
    viewBox="0 0 235.2 235.8"
  >
    <path d="M0,27c0.4-1.9,0.7-3.8,1.2-5.6C4.7,8.9,15.9,0.3,28.8,0C29.9,0,31,0,32,0c43,0,86.1,0,129.1,0c8.6,0,16.1,2.8,22.1,9  c5.6,5.7,8.3,12.6,8.3,20.6c0,20.6,0,41.1,0,61.7c0,0.3,0,0.6-0.1,0.9c-3.2-0.5-6.4-1-9.6-1.5c-1.3-0.2-2.5-0.4-3.8-0.5  c-1-0.1-1.3-0.5-1.3-1.5c0-17.6,0-35.3,0-52.9C176.9,30,175,25,171,21c-4-4.1-9-6.2-14.7-6.2c-40.3,0-80.5,0-120.8,0  c-11.6,0-20.7,9.2-20.7,21c0,13.1,0,26.2,0,39.2c0,26.9,0,53.8,0,80.6c0,9.6,5.6,17.5,14.4,20.2c2.3,0.7,4.7,1,7.1,1  c16.4,0.1,32.8,0.1,49.2,0c1.1,0,1.5,0.2,1.7,1.4c0.5,4.4,1.1,8.9,1.7,13.4c-0.4,0-0.8,0-1.2,0c-19.3,0-38.6,0-57.8,0  c-14.3,0-26.1-9.5-29.1-23.5c-0.2-1.1-0.4-2.3-0.6-3.4C0,118.8,0,72.9,0,27z M235.2,169.8c-0.2-1.5-0.4-2.9-0.5-4.4  c-0.1-0.9-0.4-1.4-1.4-1.6c-3.5-0.6-6.9-1.2-10.4-1.7c-1-0.2-1.4-0.5-1.7-1.5c-0.5-2.1-1.3-4.2-2-6.3c-0.3-0.8-0.2-1.2,0.4-1.7  c2.6-2.7,5.1-5.4,7.7-8c0.5-0.5,0.6-0.9,0.2-1.5c-1.7-2.6-3.5-5.3-5.2-7.9c-0.4-0.6-0.8-0.8-1.5-0.5c-3.5,1.3-7,2.5-10.5,3.8  c-0.7,0.3-1.2,0.2-1.7-0.3c-1.6-1.6-3.3-3.1-5.1-4.6c-0.7-0.5-0.8-1-0.6-1.8c0.9-3.6,1.8-7.1,2.6-10.7c0.1-0.4-0.1-1.1-0.4-1.3  c-3.1-1.7-6.2-3.3-9.3-5c-0.4,0.5-0.7,0.7-1,1.1c-2.3,2.8-4.7,5.6-7,8.4c-0.5,0.6-0.9,0.7-1.6,0.5c-2.2-0.5-4.4-1-6.7-1.4  c-0.9-0.2-1.3-0.5-1.5-1.4c-1-3.5-2-7.1-3.1-10.6c-0.1-0.4-0.6-0.9-0.9-0.8c-3.5,0.1-7.1,0.3-10.7,0.4c-0.7,4.2-1.4,8.2-2.1,12.2  c-0.1,0.8-0.5,1-1.2,1.2c-2,0.6-4.1,1.1-6,1.9c-1.2,0.5-1.8,0.3-2.7-0.6c-2.7-2.7-5.5-5.3-8.4-8.2c-3,2.1-5.9,4.1-8.8,6  c-0.6,0.4-0.4,0.9-0.3,1.3c1.3,3.5,2.5,7,3.8,10.5c0.3,0.8,0.2,1.2-0.4,1.8c-1.6,1.7-3.1,3.4-4.6,5.2c-0.5,0.6-0.8,0.7-1.5,0.5  c-3.6-0.9-7.3-1.8-10.9-2.7c-0.7-0.2-1.1,0-1.4,0.6c-1.4,2.8-2.8,5.6-4.2,8.3c-0.4,0.7-0.2,1.2,0.4,1.7c2.8,2.3,5.6,4.7,8.5,7  c0.6,0.5,0.7,0.9,0.5,1.6c-0.5,2.2-1.1,4.3-1.4,6.6c-0.2,1.1-0.6,1.4-1.6,1.7c-3.8,1-7.5,2.1-11.5,3.3c0.2,3.7,0.5,7.2,0.8,10.7  c0,0.3,0.6,0.8,1,0.9c3.6,0.7,7.3,1.3,11,1.9c0.7,0.1,1.1,0.4,1.3,1.1c0.7,2.3,1.4,4.5,2.2,6.7c0.2,0.7,0.2,1-0.3,1.5  c-2.6,2.6-5,5.3-7.6,7.8c-0.7,0.7-0.8,1.3-0.2,2.2c1.7,2.4,3.3,4.9,4.9,7.4c0.5,0.7,0.9,0.9,1.8,0.6c3.5-1.3,7-2.6,10.4-3.9  c0.6-0.2,1-0.2,1.5,0.3c1.7,1.6,3.5,3.2,5.3,4.8c0.5,0.4,0.7,0.8,0.5,1.5c-0.9,3.5-1.8,7.1-2.6,10.6c-0.2,0.9-0.1,1.5,0.8,1.9  c2.7,1.3,5.4,2.7,8.1,4.1c0.7,0.4,1.1,0.2,1.6-0.4c2.4-2.9,4.8-5.7,7.1-8.6c0.4-0.5,0.8-0.7,1.5-0.5c2.3,0.6,4.7,1,7,1.5  c0.6,0.1,0.9,0.3,1.1,1c1,3.5,2.1,7,3,10.6c0.3,1,0.8,1.2,1.7,1.2c2.9-0.2,5.8-0.4,8.7-0.5c1.1,0,1.4-0.5,1.6-1.5  c0.6-3.6,1.2-7.2,1.8-10.7c0.1-0.7,0.3-1,1-1.2c2.3-0.7,4.6-1.5,7-2.2c0.4-0.1,0.9,0,1.2,0.3c1.5,1.4,2.8,2.8,4.3,4.2  c1.6,1.5,3.2,2.9,4.9,4.5c2.9-2,5.7-3.9,8.5-5.7c0.7-0.4,0.8-0.9,0.5-1.6c-1.3-3.5-2.5-7-3.8-10.4c-0.3-0.7-0.2-1.1,0.3-1.6  c1.6-1.7,3.2-3.5,4.7-5.3c0.4-0.5,0.7-0.6,1.4-0.5c3.6,0.9,7.3,1.8,10.9,2.7c0.7,0.2,1.2,0.1,1.5-0.7c1.4-2.8,2.8-5.6,4.2-8.3  c0.4-0.7,0.2-1.1-0.4-1.6c-2.7-2.2-5.3-4.5-8-6.6c-1.1-0.8-1.3-1.5-0.9-2.8c0.5-1.7,0.9-3.5,1.1-5.3c0.1-1.5,0.7-2.2,2.2-2.3  c0.7-0.1,1.5-0.4,2.2-0.6c2.9-0.8,5.7-1.7,8.6-2.5C235.2,173.6,235.2,171.7,235.2,169.8z M171.9,137c19.9-0.4,36.5,15.6,36.8,35.4  c0.3,20-15.6,36.7-35.3,37c-20.3,0.3-36.8-15.5-37.1-35.4C136,153.8,151.9,137.4,171.9,137z M57.8,86.5c5.5,0,11,0.1,16.6,0  c6-0.2,10.6-5.1,10.6-11.1c0-10.4,0-20.9,0-31.3c0-7.1-4.7-11.8-11.8-11.8c-10.2,0-20.4,0-30.6,0c-7.2,0-11.9,4.7-11.9,11.9  c0,10.2,0,20.4,0,30.6c0,7.1,4.6,11.8,11.8,11.8C47.6,86.6,52.7,86.6,57.8,86.5C57.8,86.6,57.8,86.5,57.8,86.5z M57.8,160.4  c5.5,0,11,0.1,16.6,0c5.9-0.1,10.6-5,10.6-11c0-10.5,0-21,0-31.6c0-7-4.7-11.7-11.8-11.7c-10.2,0-20.5,0-30.7,0  c-7.1,0-11.8,4.7-11.8,11.8c0,10.2,0,20.4,0,30.6c0,7.2,4.6,11.8,11.9,11.9C47.7,160.5,52.7,160.5,57.8,160.4  C57.8,160.5,57.8,160.4,57.8,160.4z M150.1,86.6c7,0,11.6-4.8,11.6-11.7c0-10.3,0-20.6,0-30.8c0-7-4.7-11.7-11.8-11.7  c-10.2,0-20.5,0-30.7,0c-7.1,0-11.8,4.7-11.8,11.8c0,10.2,0,20.5,0,30.7c0,0.8,0,1.7,0.2,2.5c1,5.6,5.4,9.2,11.3,9.3  c5.2,0,10.5,0,15.7,0C139.8,86.6,145,86.6,150.1,86.6z M188.7,173c0-8.6-7-15.5-15.6-15.5c-8.5,0-15.5,7-15.5,15.5  c0,8.6,6.9,15.6,15.5,15.6C181.8,188.6,188.7,181.6,188.7,173z" />
  </svg>
);
export const AccountsBilling = () => (
  <svg
    version="1.1"
    width="1em"
    height="1em"
    fill="currentColor"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 197.5 228.5"
  >
    <path d="M197.5,98.4c-0.1,0.2-0.2,0.4-0.2,0.5c-0.5,2.6-2,4.3-4.4,5.5c-12.1,5.9-24.2,11.9-36.3,17.9c-15,7.4-30,14.8-45,22.2  c-0.4,0.2-0.8,0.4-1.3,0.6c0-1,0-1.7,0-2.5c0-4.9,0-9.8,0-14.8c0-0.9,0.3-1.3,1.1-1.7c21.6-10.6,43.3-21.3,64.9-32  c0.5-0.2,1-0.5,1.5-0.8c-6.3-13.1-12.6-26.2-19-39.4c-37.4,18.7-74.7,37.3-112.1,56c0.2,0.6,0.4,1,0.7,1.5  c2.8,5.8,5.6,11.7,8.4,17.5c0.3,0.6,0.5,1.2,0.5,1.8c0,11.7,0,23.4,0,35c0,0.2,0,0.5-0.1,0.7c-0.1,0.1-0.2,0.1-0.3,0.2  c-0.5-0.8-1.1-1.6-1.6-2.5c-5.5-11.4-11-22.7-16.4-34.1C29,111.6,20.1,93.2,11.3,74.8c-1.5-3.1-1.4-6,0.9-8.6c0.8-0.9,1.9-1.6,3-2.1  c27.6-13.6,55.2-27.2,82.7-40.8c14.9-7.4,29.9-14.7,44.8-22.1c1-0.5,2.1-0.9,3.2-1.3c0.6,0,1.1,0,1.7,0c3.4,0.7,5.2,3,6.6,6  c8.3,17.6,16.8,35,25.2,52.6c6.1,12.7,12.1,25.4,18.1,38.2C197.5,97.3,197.5,97.8,197.5,98.4z M142.4,19.9  C104.8,38.5,67.4,56.9,30,75.3c2.2,4.7,4.4,9.1,6.6,13.8C74,70.4,111.3,51.7,148.7,33C146.6,28.6,144.6,24.4,142.4,19.9z M0,164.2  c0.3,2,0.6,4,1,6c1.5,6.9,4.3,13.4,8.2,19.3c2.2,3.4,5.2,6.2,7.9,9.3c8.3,9.6,16.6,19.2,24.8,28.7c0.2,0.3,0.4,0.7,0.6,1  c21.7,0,43.4,0,65,0c-0.2-1.4-0.4-2.8-0.5-4.3c-0.6-5.2-1.2-10.3-1.8-15.5c-0.6-5.3-1.2-10.6-1.8-15.9c-0.5-4.5-1.1-9-1.6-13.6  c-0.4-4.4-1-8.7-1-13.1c-0.1-14.7,0-29.4-0.1-44.2c0-1.2-0.1-2.4-0.2-3.6c-1.3-8.6-9.4-16.2-20-14.5c-9.1,1.4-14.9,8.7-14.9,17.9  c0,17.7,0,35.4,0,53c0,3.8,0,4-3.9,4c-7.6,0.1-13.3-3.3-16.6-10.1c-7.4-15.2-14.7-30.5-22-45.8c-0.2-0.4-0.4-0.8-0.7-1.3  c-0.3,0.5-0.6,0.8-0.8,1.2C16.3,131,11,139.2,5.7,147.4c-0.2,0.3-0.4,0.7-0.7,1c-2.3,2.3-3.6,5.2-4.2,8.3c-0.3,1.4-0.5,2.7-0.7,4.1  C0,161.9,0,163,0,164.2z" />
  </svg>
);
export const TrackingTravelers = () => (
  <svg
    version="1.1"
    width="1em"
    height="1em"
    fill="currentColor"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 61.2 53.3"
  >
    <path d="M42.7,0c0.6,0.1,1.2,0.3,1.9,0.4c11,2.3,15.8,15.5,8.7,24.1c-4.1,4.9-8.9,9.3-13.5,14c-2.6-1.9-5-3.7-7.5-5.6  c-0.3-0.2-0.4-0.7-0.4-1c0-1.3,0.1-2.6-0.1-4c-0.1-0.6-0.3-1.4-0.8-1.9c-6-6.3-5.9-15.9,0.4-22c2.2-2.1,4.8-3.3,7.7-3.8  c0.3-0.1,0.7-0.2,1-0.3C41.1,0,41.9,0,42.7,0z M41.6,33.4c3.4-3.5,6.9-6.7,9.9-10.4c4.7-5.7,3.1-14.4-3-18.5C43.1,0.8,36,1.9,31.8,7  c-4.2,5-3.9,12.5,0.6,17.2c2.8,2.9,5.6,5.7,8.4,8.5C41,32.9,41.3,33.1,41.6,33.4z M19.7,22.9c-3.1,1.1-5.8,2.1-8.5,3.1  c-0.5,0.2-1.1,0.8-1.3,1.3C7.4,33.7,5,40,2.6,46.3c-0.9,2.3-1.7,4.5-2.6,6.9c0.3,0,0.5,0.1,0.6,0C5.1,52.1,9.5,51,14,49.9  c0.3-0.1,0.7-0.5,0.8-0.9c0.5-2.1,0.8-4.2,1.3-6.3c0.2-0.7,0-1.1-0.7-1.4c-1.9-0.8-3.7-1.6-5.6-2.4c-0.9-0.4-1.2-1.1-0.8-1.9  c0.4-0.9,1.2-0.7,2-0.4c1.9,0.8,3.7,1.7,5.7,2.6C17.7,33.7,18.7,28.4,19.7,22.9z M52.2,29.7c-2.5,2.4-4.8,4.8-7.2,7  c-0.6,0.6-0.7,1.1-0.6,1.9c0.7,3.3,1.3,6.7,1.9,10c0.2,0.9,0.5,1.3,1.4,1.5c3.8,0.9,7.5,1.8,11.3,2.7c0.6,0.2,1.3,0.3,2.2,0.5  C58.1,45.3,55.2,37.5,52.2,29.7z M28.8,35.8c-3.2,1.9-6.4,3.8-9.6,5.7c-0.3,0.2-0.6,0.7-0.6,1.1c-0.4,2.1-0.8,4.2-1.2,6.2  c-0.2,0.8,0.1,1.1,0.8,1.2c1.9,0.5,3.9,1,5.8,1.5c1.7,0.5,3.4,0.9,5.3,1.4c0-5.9,0-11.5,0-17.3C29,35.8,28.9,35.8,28.8,35.8z   M32,53.1c0.6-0.2,1.1-0.3,1.6-0.4c2.8-0.8,5.6-1.5,8.4-2.3c2.2-0.6,2-0.2,1.6-2.5c-0.5-2.6-1-5.2-1.5-7.8c-0.1-0.1-0.3-0.2-0.4-0.2  c-0.3,0.4-0.6,0.9-0.9,1.3c-0.5,0.7-1,0.8-1.7,0.2c-0.9-0.8-1.9-1.4-2.8-2.1c-1.4-1-2.8-2.1-4.3-3.2C32,41.8,32,47.4,32,53.1z   M28.8,32.7c0.2-0.1,0.4-0.4,0.4-0.7c0-1.9,0-3.8,0-5.7c0-0.2-0.2-0.6-0.4-0.7c-2.1-0.9-4.3-1.8-6.6-2.8c-1,5.2-1.9,10.1-3,15.5  C22.7,36.4,25.8,34.6,28.8,32.7z M41.5,22.2c3.9,0,7-3.2,7.1-7.1c0-3.9-3.2-7.1-7-7.1c-3.9,0-7,3.2-7,7.2  C34.5,19,37.7,22.2,41.5,22.2z" />
  </svg>
);
export const Reports = () => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    width="1em"
    height="1em"
    fill="currentColor"
    y="0px"
    viewBox="0 0 87 76.2"
  >
    <path d="M81,73.3V32.2c0-2.8-2.3-5.1-5.2-5.1H68v37.2h-3V3.8c0-0.1,0-0.2,0-0.2c0-0.1,0-0.3,0-0.5c0-1.1,0.3-2.1,0.8-3H26  c-0.2,0.1-0.5,0.2-0.7,0.2c-2.9,0-5.3,2.4-5.3,5.3c0,0.1,0,0.3-0.1,0.4v58.3h-3V27.1h-5.8c-2.8,0-5.1,2.2-5.2,5.1v41H0v3h87v-3  L81,73.3z M26.1,55.3H23v-3h3.1V55.3z M26.1,47.3H23v-3h3.1V47.3z M26.1,39.3H23v-3h3.1V39.3z M26.1,31.3H23v-3h3.1V31.3z   M26.1,23.3H23v-3h3.1V23.3z M26.1,15.3H23v-3h3.1V15.3z M60,55.3H30v-3h30V55.3z M60,47.3H30v-3h30V47.3z M60,39.3H30v-3h30V39.3z   M60,31.3H30v-3h30V31.3z M60,23.3H30v-3h30V23.3z M60,15.3H30v-3h30V15.3z M74.2,12.2H68V3.8c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.2  C68,1.4,69.4,0,71.1,0c1.7,0,3.1,1.4,3.1,3.1c0,0.1,0,0.1,0,0.2L74.2,12.2z" />
  </svg>
);
export const Leads = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="1em"
    height="1em"
    fill="currentColor"
    x="0px"
    y="0px"
    viewBox="0 0 63.9 53.6"
  >
    <path d="M59.7,22.5c-2,0-3.7,1.4-4.1,3.3h-5l-8.4-14.5l3.4-3.4c2.9,1.7,6.5-0.3,6.5-3.6c0-1.1-0.5-2.2-1.3-3c-3.6-3.5-9.2,1-6.6,5.2  l-3.6,3.6H23.4l-3.6-3.6c2.6-4.3-3.1-8.8-6.6-5.2c-3.6,3.5,0.9,9.2,5.2,6.6l3.4,3.4l-8.4,14.5h-5c-0.5-1.9-2.1-3.3-4.1-3.3  c-2.4,0-4.3,2-4.3,4.3s1.9,4.3,4.3,4.3c2,0,3.7-1.4,4.1-3.3h5c0,0,2.4,4.1,8.4,14.5l-3.4,3.4c-2.9-1.7-6.5,0.4-6.5,3.6  c0,1.1,0.4,2.2,1.3,3c3.4,3.4,9.3-0.8,6.6-5.2l3.6-3.6h17.2l3.6,3.6c-2.7,4.4,3.1,8.7,6.6,5.2s-0.9-9.3-5.2-6.7l-3.4-3.4  c0,0,0,0,0.1-0.1l0,0l0,0l0,0l0,0c0.4-0.8,2.2-3.8,8.2-14.2h5c0.5,1.9,2.1,3.3,4.1,3.3c2.4,0,4.3-1.9,4.3-4.3S62.1,22.5,59.7,22.5z   M45.8,32.1c-1.9-2.6-6.5-3-9.7-3.3c-0.6-0.1-1.1,0.4-1.1,1c-0.2,1.2,0.4,3.3-2.8,6.9c-2-2.2-2.8-4.2-2.8-6.8c0-0.6-0.5-1.1-1.1-1  c-3.4,0.4-8.4,0.8-10,3.7l-3.2-5.8l8.4-14.6h16.9l8.5,14.6L45.8,32.1z M38.2,19.8c0,3.3-2.7,7.2-6,7.2s-6-3.9-6-7.2s2.7-6,6-6  S38.2,16.5,38.2,19.8z" />
  </svg>
);
export const Settings = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="1em"
    height="1em"
    fill="currentColor"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
  >
    <path
      d="M487.4,315.7l-42.6-24.6c4.3-23.2,4.3-47,0-70.2l42.6-24.6c4.9-2.8,7.1-8.6,5.5-14c-11.1-35.6-30-67.8-54.7-94.6
	c-3.8-4.1-10-5.1-14.8-2.3L380.8,110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7c-36.7-8.2-74.3-7.8-109.2,0
	c-5.5,1.2-9.4,6.1-9.4,11.7V75c-22.2,7.9-42.8,19.8-60.8,35.1L88.7,85.5c-4.9-2.8-11-1.9-14.8,2.3c-24.7,26.7-43.6,58.9-54.7,94.6
	c-1.7,5.4,0.6,11.2,5.5,14L67.3,221c-4.3,23.2-4.3,47,0,70.2l-42.6,24.6c-4.9,2.8-7.1,8.6-5.5,14c11.1,35.6,30,67.8,54.7,94.6
	c3.8,4.1,10,5.1,14.8,2.3l42.6-24.6c17.9,15.4,38.5,27.3,60.8,35.1v49.2c0,5.6,3.9,10.5,9.4,11.7c36.7,8.2,74.3,7.8,109.2,0
	c5.5-1.2,9.4-6.1,9.4-11.7v-49.2c22.2-7.9,42.8-19.8,60.8-35.1l42.6,24.6c4.9,2.8,11,1.9,14.8-2.3c24.7-26.7,43.6-58.9,54.7-94.6
	C494.5,324.3,492.3,318.5,487.4,315.7z M256,336c-44.1,0-80-35.9-80-80s35.9-80,80-80s80,35.9,80,80S300.1,336,256,336z"
    />
  </svg>
);
export const Countries = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="1em"
    height="1em"
    x="0px"
    y="0px"
    viewBox="0 0 496 512"
  >
    <path
      d="M248,8C111,8,0,119,0,256s111,248,248,248s248-111,248-248S385,8,248,8z M330.3,365.6c-3.9,3.9-8,8-11.3,11.3
	c-3,3-5.1,6.7-6.2,10.7c-1.5,5.7-2.7,11.4-4.8,16.9l-17.4,46.9c-13.8,3-28,4.7-42.6,4.7v-27.4c1.7-12.6-7.6-36.3-22.6-51.2
	c-6-6-9.4-14.1-9.4-22.6v-32c0-11.6-6.3-22.3-16.5-28c-14.4-8-34.8-19.1-48.8-26.1c-11.5-5.8-22.1-13.1-31.7-21.8l-0.8-0.7
	c-6.8-6.2-12.9-13.1-18.1-20.7c-9.4-13.8-24.7-36.4-34.6-51.1c20.5-45.5,57.4-82,103.2-101.9l24,12C203.5,89.7,216,82,216,70.1V58.8
	c8-1.3,16.1-2.1,24.4-2.4l28.3,28.3c6.2,6.2,6.2,16.4,0,22.6L264,112l-10.3,10.3c-3.1,3.1-3.1,8.2,0,11.3l4.7,4.7
	c3.1,3.1,3.1,8.2,0,11.3l-8,8c-1.5,1.5-3.5,2.3-5.7,2.3h-9c-2.1,0-4.1,0.8-5.6,2.3l-9.9,9.6c-2.5,2.4-3.1,6.2-1.6,9.3l15.6,31.2
	c2.7,5.3-1.2,11.6-7.1,11.6h-5.6c-1.9,0-3.8-0.7-5.2-2l-9.3-8.1c-4.3-3.7-10.2-4.9-15.6-3.1l-31.2,10.4c-4.9,1.6-8.2,6.2-8.2,11.3
	c0,4.5,2.6,8.7,6.6,10.7l11.1,5.5c9.4,4.7,19.8,7.2,30.3,7.2s22.6,27.3,32,32h66.8c8.5,0,16.6,3.4,22.6,9.4l13.7,13.7
	c5.7,5.7,8.9,13.5,8.9,21.6C344,345,339.1,356.9,330.3,365.6z M417,274.2c-5.8-1.5-10.8-5-14.1-10l-18-27c-5.4-8.1-5.4-18.6,0-26.6
	l19.6-29.4c2.3-3.5,5.5-6.3,9.2-8.1l13-6.5c13.5,26.9,21.3,57.2,21.3,89.3c0,8.7-0.7,17.2-1.8,25.5L417,274.2z"
    />
  </svg>
);
export const Email = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="1em"
    height="1em"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
  >
    <path
      d="M502.3,190.8c3.9-3.1,9.7-0.2,9.7,4.7V400c0,26.5-21.5,48-48,48H48c-26.5,0-48-21.5-48-48V195.6c0-5,5.7-7.8,9.7-4.7
	c22.4,17.4,52.1,39.5,154.1,113.6c21.1,15.4,56.7,47.8,92.2,47.6c35.7,0.3,72-32.8,92.3-47.6C450.3,230.4,479.9,208.2,502.3,190.8z
	 M256,320c23.2,0.4,56.6-29.2,73.4-41.4c132.7-96.3,142.8-104.7,173.4-128.7c5.8-4.5,9.2-11.5,9.2-18.9v-19c0-26.5-21.5-48-48-48H48
	C21.5,64,0,85.5,0,112v19c0,7.4,3.4,14.3,9.2,18.9c30.6,23.9,40.7,32.4,173.4,128.7C199.4,290.8,232.8,320.4,256,320L256,320z"
    />
  </svg>
);
export const Mobile = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="1em"
    height="1em"
    x="0px"
    y="0px"
    viewBox="0 0 384 512"
  >
    <path
      d="M336,0H48C21.5,0,0,21.5,0,48v416c0,26.5,21.5,48,48,48h288c26.5,0,48-21.5,48-48V48C384,21.5,362.5,0,336,0z M144,32h96
	c8.8,0,16,7.2,16,16s-7.2,16-16,16h-96c-8.8,0-16-7.2-16-16S135.2,32,144,32z M192,160c35.3,0,64,28.7,64,64s-28.7,64-64,64
	s-64-28.7-64-64S156.7,160,192,160z M304,396.8c0,10.6-10,19.2-22.4,19.2H102.4C90,416,80,407.4,80,396.8v-19.2
	c0-31.8,30.1-57.6,67.2-57.6h5c12.3,5.1,25.7,8,39.8,8s27.6-2.9,39.8-8h5c37.1,0,67.2,25.8,67.2,57.6V396.8z"
    />
  </svg>
);
export const Reporting = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="1em"
    height="1em"
    x="0px"
    y="0px"
    viewBox="0 0 576 512"
  >
    <path
      d="M528,32H48C21.5,32,0,53.5,0,80v16h576V80C576,53.5,554.5,32,528,32z M0,432c0,26.5,21.5,48,48,48h480c26.5,0,48-21.5,48-48
	V128H0V432z M352,200c0-4.4,3.6-8,8-8h144c4.4,0,8,3.6,8,8v16c0,4.4-3.6,8-8,8H360c-4.4,0-8-3.6-8-8V200z M352,264c0-4.4,3.6-8,8-8
	h144c4.4,0,8,3.6,8,8v16c0,4.4-3.6,8-8,8H360c-4.4,0-8-3.6-8-8V264z M352,328c0-4.4,3.6-8,8-8h144c4.4,0,8,3.6,8,8v16
	c0,4.4-3.6,8-8,8H360c-4.4,0-8-3.6-8-8V328z M176,192c35.3,0,64,28.7,64,64s-28.7,64-64,64s-64-28.7-64-64S140.7,192,176,192z
	 M67.1,396.2C75.5,370.5,99.6,352,128,352h8.2c12.3,5.1,25.7,8,39.8,8s27.6-2.9,39.8-8h8.2c28.4,0,52.5,18.5,60.9,44.2
	c3.2,9.9-5.2,19.8-15.6,19.8H82.7C72.3,416,63.9,406,67.1,396.2z"
    />
  </svg>
);
export const Overview = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="1em"
    height="1em"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
  >
    <path
      d="M416,48c0-8.8-7.2-16-16-16h-64c-8.8,0-16,7.2-16,16v48h96V48z M63.9,160C61.4,253.8,3.5,274.2,0,404v44
	c0,17.7,14.3,32,32,32h96c17.7,0,32-14.3,32-32V288h32V128H95.8C78.2,128,64.4,142.4,63.9,160z M448.1,160
	c-0.5-17.6-14.3-32-31.9-32H320v160h32v160c0,17.7,14.3,32,32,32h96c17.7,0,32-14.3,32-32v-44C508.5,274.2,450.6,253.8,448.1,160z
	 M176,32h-64c-8.8,0-16,7.2-16,16v48h96V48C192,39.2,184.8,32,176,32z M224,288h64V128h-64V288z"
    />
  </svg>
);
export const Alerts = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="0.70em"
    height="0.70em"
    x="0px"
    y="0px"
    viewBox="0 0 448 512"
  >
    <path
      d="M224,512c35.3,0,64-28.6,64-64H160C160,483.4,188.7,512,224,512z M439.4,362.3c-19.3-20.8-55.5-52-55.5-154.3
	c0-77.7-54.5-139.9-127.9-155.2V32c0-17.7-14.3-32-32-32s-32,14.3-32,32v20.8C118.6,68.1,64.1,130.3,64.1,208
	c0,102.3-36.2,133.5-55.5,154.3C2.6,368.7,0,376.4,0,384c0.1,16.4,13,32,32.1,32h383.8c19.1,0,32-15.6,32.1-32
	C448,376.4,445.4,368.7,439.4,362.3z"
    />
  </svg>
);
export const Flight = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="0.70em"
    height="0.70em"
    x="0px"
    y="0px"
    viewBox="0 0 576 512"
  >
    <path
      d="M480,192H365.7L260.6,8.1c-2.9-5-8.2-8.1-13.9-8.1h-65.5c-10.6,0-18.3,10.2-15.4,20.4l49,171.6H112l-43.2-57.6
	c-3-4-7.8-6.4-12.8-6.4H16c-10.4,0-18,9.8-15.5,19.9L32,256L0.5,364.1C-2,374.2,5.6,384,16,384h40c5,0,9.8-2.4,12.8-6.4L112,320
	h102.9l-49,171.6c-2.9,10.2,4.8,20.4,15.4,20.4h65.5c5.7,0,11-3.1,13.9-8.1L365.7,320H480c35.3,0,96-28.6,96-64S515.3,192,480,192z"
    />
  </svg>
);
export const Booking = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="0.70em"
    height="0.70em"
    x="0px"
    y="0px"
    viewBox="0 0 576 512"
  >
    <path
      d="M128,160h320v192H128V160z M528,256c0,26.5,21.5,48,48,48v96c0,26.5-21.5,48-48,48H48c-26.5,0-48-21.5-48-48v-96
	c26.5,0,48-21.5,48-48s-21.5-48-48-48v-96c0-26.5,21.5-48,48-48h480c26.5,0,48,21.5,48,48v96C549.5,208,528,229.5,528,256z M480,152
	c0-13.3-10.7-24-24-24H120c-13.3,0-24,10.7-24,24v208c0,13.3,10.7,24,24,24h336c13.3,0,24-10.7,24-24V152z"
    />
  </svg>
);
export const Vip = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="0.70em"
    height="0.70em"
    x="0px"
    y="0px"
    viewBox="0 0 576 512"
  >
    <path
      d="M259.3,17.8L194,150.2L47.9,171.5c-26.2,3.8-36.7,36.1-17.7,54.6l105.7,103l-25,145.5c-4.5,26.3,23.2,46,46.4,33.7
	L288,439.6l130.7,68.7c23.2,12.2,50.9-7.4,46.4-33.7l-25-145.5l105.7-103c19-18.5,8.5-50.8-17.7-54.6L382,150.2L316.7,17.8
	C305-5.8,271.1-6.1,259.3,17.8L259.3,17.8z"
    />
  </svg>
);
export const Traveler = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="0.70em"
    height="0.70em"
    x="0px"
    y="0px"
    viewBox="0 0 448 512"
  >
    <path
      d="M383.9,308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9,17.8-40.6,17.8-64v-0.3c39.2-7.8,64-19.1,64-31.7
	c0-13.3-27.3-25.1-70.1-33c-9.2-32.8-27-65.8-40.6-82.8c-9.5-11.9-25.9-15.6-39.5-8.8l-27.6,13.8c-9,4.5-19.6,4.5-28.6,0L182.1,3.4
	c-13.6-6.8-30-3.1-39.5,8.8c-13.5,17-31.4,50-40.6,82.8c-42.7,7.9-70,19.7-70,33c0,12.6,24.8,23.9,64,31.7v0.3
	c0,23.4,6.8,45.1,17.8,64H56.3c-11.5,0-19.2,11.7-14.7,22.3l25.8,60.2C27.3,329.8,0,372.7,0,422.4v44.8C0,491.9,20.1,512,44.8,512
	h358.4c24.7,0,44.8-20.1,44.8-44.8v-44.8C448,374,422.2,332,383.9,308.3L383.9,308.3z M176,480l-41.6-192l49.6,32l24,40L176,480z
	 M272,480l-32-120l24-40l49.6-32L272,480z M313.7,181.5c-3.9,11.9-7,24.6-16.5,33.4c-10.1,9.3-48,22.4-64-25
	c-2.8-8.4-15.4-8.4-18.3,0c-17,50.2-56,32.4-64,25c-9.5-8.8-12.7-21.5-16.5-33.4c-0.8-2.5-6.3-5.7-6.3-5.8v-10.8
	c28.3,3.6,61,5.8,96,5.8s67.7-2.1,96-5.8v10.8C320,175.8,314.5,178.9,313.7,181.5z"
    />
  </svg>
);
export const Hotels = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="0.70em"
    height="0.70em"
    x="0px"
    y="0px"
    viewBox="0 0 576 512"
  >
    <path
      d="M560,64c8.8,0,16-7.2,16-16V16c0-8.8-7.2-16-16-16H16C7.2,0,0,7.2,0,16v32c0,8.8,7.2,16,16,16h16v384H16
	c-8.8,0-16,7.2-16,16v32c0,8.8,7.2,16,16,16h240v-80c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16v80h240c8.8,0,16-7.2,16-16v-32
	c0-8.8-7.2-16-16-16h-16V64H560z M256,108.8c0-6.4,6.4-12.8,12.8-12.8h38.4c6.4,0,12.8,6.4,12.8,12.8v38.4c0,6.4-6.4,12.8-12.8,12.8
	h-38.4c-6.4,0-12.8-6.4-12.8-12.8L256,108.8L256,108.8z M256,204.8c0-6.4,6.4-12.8,12.8-12.8h38.4c6.4,0,12.8,6.4,12.8,12.8v38.4
	c0,6.4-6.4,12.8-12.8,12.8h-38.4c-6.4,0-12.8-6.4-12.8-12.8L256,204.8L256,204.8z M128,108.8c0-6.4,6.4-12.8,12.8-12.8h38.4
	c6.4,0,12.8,6.4,12.8,12.8v38.4c0,6.4-6.4,12.8-12.8,12.8h-38.4c-6.4,0-12.8-6.4-12.8-12.8L128,108.8L128,108.8z M179.2,256h-38.4
	c-6.4,0-12.8-6.4-12.8-12.8v-38.4c0-6.4,6.4-12.8,12.8-12.8h38.4c6.4,0,12.8,6.4,12.8,12.8v38.4C192,249.6,185.6,256,179.2,256
	L179.2,256z M192,384c0-53,43-96,96-96s96,43,96,96H192z M448,243.2c0,6.4-6.4,12.8-12.8,12.8h-38.4c-6.4,0-12.8-6.4-12.8-12.8
	v-38.4c0-6.4,6.4-12.8,12.8-12.8h38.4c6.4,0,12.8,6.4,12.8,12.8V243.2L448,243.2z M448,147.2c0,6.4-6.4,12.8-12.8,12.8h-38.4
	c-6.4,0-12.8-6.4-12.8-12.8v-38.4c0-6.4,6.4-12.8,12.8-12.8h38.4c6.4,0,12.8,6.4,12.8,12.8V147.2z"
    />
  </svg>
);
export const Risklevel = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="0.70em"
    height="0.70em"
    x="0px"
    y="0px"
    viewBox="0 0 448 512"
  >
    <path
      d="M439.1,453.1l-142-69.1l142-69.1c7.9-4,11.1-13.6,7.1-21.5L432,264.9c-4-7.9-13.6-11.1-21.5-7.2L224,348.4L37.5,257.7
	c-7.9-3.9-17.5-0.8-21.5,7.2L1.7,293.5c-4,7.9-0.8,17.5,7.2,21.5l142,69.1l-142,69.1c-7.9,4-11.1,13.6-7.2,21.5L16,503.2
	c4,7.9,13.6,11.1,21.5,7.1L224,419.6l186.5,90.7c7.9,4,17.5,0.8,21.5-7.1l14.3-28.6C450.3,466.6,447,457,439.1,453.1z M150,237.3
	l-5.5,25.9c-2.7,12.6,5.4,24.9,16.4,24.9H287c11,0,19.1-12.2,16.5-24.9l-5.5-25.9c41.8-22.4,70-62.8,70-109.3
	C368,57.3,303.5,0,224,0S80,57.3,80,128C80,174.5,108.2,214.9,150,237.3z M280,112c17.6,0,32,14.3,32,32s-14.4,32-32,32
	s-32-14.4-32-32S262.4,112,280,112z M168,112c17.6,0,32,14.3,32,32s-14.4,32-32,32s-32-14.4-32-32S150.4,112,168,112z"
    />
  </svg>
);
export const Geofencing = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="0.70em"
    height="0.70em"
    x="0px"
    y="0px"
    viewBox="0 0 384 512"
  >
    <path
      d="M172.3,501.7C27,291,0,269.4,0,192C0,86,86,0,192,0s192,86,192,192c0,77.4-27,99-172.3,309.7
	C202.2,515.4,181.8,515.4,172.3,501.7L172.3,501.7z M192,272c44.2,0,80-35.8,80-80s-35.8-80-80-80s-80,35.8-80,80S147.8,272,192,272
	z"
    />
  </svg>
);
export const Orderhistory = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="0.70em"
    height="0.70em"
    x="0px"
    y="0px"
    viewBox="0 0 576 512"
  >
    <path
      d="M576,216v16c0,13.3-10.7,24-24,24h-8l-26.1,182.8c-3.4,23.6-23.6,41.2-47.5,41.2H105.6c-23.9,0-44.1-17.6-47.5-41.2L32,256
	h-8c-13.3,0-24-10.7-24-24v-16c0-13.3,10.7-24,24-24h67.3L198.1,45.2c10.4-14.3,30.4-17.5,44.7-7.1c14.3,10.4,17.5,30.4,7.1,44.7
	L170.5,192h235L326.1,82.8c-10.4-14.3-7.2-34.3,7.1-44.7c14.3-10.4,34.3-7.2,44.7,7.1L484.7,192H552C565.3,192,576,202.7,576,216z
	 M312,392V280c0-13.3-10.7-24-24-24s-24,10.7-24,24v112c0,13.3,10.7,24,24,24S312,405.3,312,392z M424,392V280c0-13.3-10.7-24-24-24
	s-24,10.7-24,24v112c0,13.3,10.7,24,24,24S424,405.3,424,392z M200,392V280c0-13.3-10.7-24-24-24s-24,10.7-24,24v112
	c0,13.3,10.7,24,24,24S200,405.3,200,392z"
    />
  </svg>
);
export const Uploaditinerary = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="0.70em"
    height="0.70em"
    x="0px"
    y="0px"
    viewBox="0 0 384 512"
  >
    <path
      d="M336,64h-80c0-35.3-28.7-64-64-64s-64,28.7-64,64H48C21.5,64,0,85.5,0,112v352c0,26.5,21.5,48,48,48h288
	c26.5,0,48-21.5,48-48V112C384,85.5,362.5,64,336,64z M96,424c-13.3,0-24-10.7-24-24s10.7-24,24-24s24,10.7,24,24S109.3,424,96,424z
	 M96,328c-13.3,0-24-10.7-24-24s10.7-24,24-24s24,10.7,24,24S109.3,328,96,328z M96,232c-13.3,0-24-10.7-24-24s10.7-24,24-24
	s24,10.7,24,24S109.3,232,96,232z M192,40c13.3,0,24,10.7,24,24s-10.7,24-24,24s-24-10.7-24-24S178.7,40,192,40z M320,408
	c0,4.4-3.6,8-8,8H168c-4.4,0-8-3.6-8-8v-16c0-4.4,3.6-8,8-8h144c4.4,0,8,3.6,8,8V408z M320,312c0,4.4-3.6,8-8,8H168
	c-4.4,0-8-3.6-8-8v-16c0-4.4,3.6-8,8-8h144c4.4,0,8,3.6,8,8V312z M320,216c0,4.4-3.6,8-8,8H168c-4.4,0-8-3.6-8-8v-16
	c0-4.4,3.6-8,8-8h144c4.4,0,8,3.6,8,8V216z"
    />
  </svg>
);
export const Buynow = () => (
  <svg
    version="1.1"
    id="Layer_1"
    width="0.70em"
    height="0.70em"
    x="0px"
    y="0px"
    viewBox="0 0 576 512"
  >
    <path
      d="M528.1,301.3l47.3-208c3.4-15-8-29.3-23.4-29.3H159.2L150,19.2C147.8,8,137.9,0,126.5,0H24C10.7,0,0,10.7,0,24v16
	c0,13.3,10.7,24,24,24h69.9l70.2,343.4c-16.8,9.7-28.1,27.8-28.1,48.6c0,30.9,25.1,56,56,56s56-25.1,56-56c0-15.7-6.4-29.8-16.8-40
	h209.6c-10.4,10.2-16.8,24.3-16.8,40c0,30.9,25.1,56,56,56s56-25.1,56-56c0-22.2-12.9-41.3-31.6-50.4l5.5-24.3
	c3.4-15-8-29.3-23.4-29.3H218.1l-6.5-32h293.1C515.9,320,525.6,312.2,528.1,301.3z"
    />
  </svg>
);

export const CustomAlert = () => (
  <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 100 100">
    <g>
      <path
        className="st0"
        d="M19,24.8c1.7,0,3.1-1.4,3.1-3.1v-9.2c0-1.7-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1v9.2C15.9,23.4,17.3,24.8,19,24.8
		z"
      />
      <path
        className="st0"
        d="M80,24.8c1.7,0,3.1-1.4,3.1-3.1v-9.2c0-1.7-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1v9.2C77,23.4,78.4,24.8,80,24.8z"
      />
      <path
        className="st0"
        d="M87.7,17.2h-1.5v4.6c0,3.4-2.7,6.1-6.1,6.1c-0.2,0-0.4,0-0.6,0c-3.2-0.4-5.6-3.2-5.5-6.4v-4.3H25.1v4.6
		c0,3.4-2.7,6.1-6.1,6.1c-0.2,0-0.4,0-0.6,0c-3.2-0.4-5.6-3.2-5.5-6.4v-4.3h-1.5c-2.5,0-4.6,2.1-4.6,4.6v10.7c0,0.8,0.7,1.5,1.5,1.5
		h82.5c0.8,0,1.5-0.7,1.5-1.5V21.7C92.3,19.2,90.2,17.2,87.7,17.2z"
      />
      <ellipse className="st0" cx="57.6" cy="70.3" rx="4.6" ry="4.6" />
      <ellipse className="st0" cx="57.6" cy="53.9" rx="4.6" ry="4.6" />
      <ellipse className="st0" cx="42" cy="70.3" rx="4.6" ry="4.6" />
      <circle className="st0" cx="25.8" cy="70.3" r="4.6" />
      <circle className="st0" cx="25.8" cy="53.9" r="4.6" />
      <ellipse className="st0" cx="42" cy="53.9" rx="4.6" ry="4.6" />
      <ellipse className="st0" cx="74" cy="53.9" rx="4.6" ry="4.6" />
      <path
        className="st0"
        d="M84.2,90.5c1.5,0,2.8-0.7,3.4-2h-6.8C81.4,89.7,82.7,90.5,84.2,90.5z"
      />
      <path
        className="st0"
        d="M70.1,84.8v-0.3c0-1.3,0.4-2.6,1.3-3.5c1.2-1.3,1.9-3.1,1.9-5v-4.2c0-4.7,3.1-8.7,7.4-10.2
		c0.7-1.3,2-2.3,3.6-2.3s2.9,0.9,3.6,2.3c1.7,0.6,3.1,1.6,4.3,2.8V38.5c0-0.8-0.7-1.5-1.5-1.5H8.3c-0.8,0-1.5,0.7-1.5,1.5v44.3
		c0,2.5,2.1,4.6,4.6,4.6h60.2C70.8,86.7,70.3,85.9,70.1,84.8z M25.8,74.9c-2.5,0-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6s4.6,2.1,4.6,4.6
		S28.3,74.9,25.8,74.9z M25.8,58.5c-2.5,0-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6s4.6,2.1,4.6,4.6S28.3,58.5,25.8,58.5z M42,74.9
		c-2.5,0-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6s4.6,2.1,4.6,4.6S44.6,74.9,42,74.9z M42,58.5c-2.5,0-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6
		s4.6,2.1,4.6,4.6S44.6,58.5,42,58.5z M57.6,74.9c-2.5,0-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6s4.6,2.1,4.6,4.6
		C62.2,72.8,60.2,74.9,57.6,74.9z M57.6,58.5c-2.5,0-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6s4.6,2.1,4.6,4.6
		C62.2,56.4,60.2,58.5,57.6,58.5z M74,49.3c2.5,0,4.6,2.1,4.6,4.6s-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6C69.4,51.4,71.5,49.3,74,49.3z"
      />
      <path
        className="st0"
        d="M94.7,79.9c-1.1-1.1-1.5-2.5-1.5-4v-2.6c0.1-2.4-0.8-4.8-2.4-6.5c-0.9-1-2.1-1.8-3.5-2.3
		c-0.6-1.2-1.6-1.9-2.9-1.9s-2.4,0.8-2.9,1.9c-3.5,1.2-6,4.5-6,8.2v3.4c0,1.5-0.6,2.9-1.5,4c-0.7,0.7-1.1,1.8-1.1,2.8v0.2
		c0.2,0.9,0.6,1.6,1.2,2.1c0.7,0.6,1.7,1,2.7,0.9h2.1c0.8,3.1,3.9,4.8,6.9,4c2-0.5,3.5-2,4-4h2c1.9,0,3.5-1.3,4-3.1
		C95.8,81.9,95.4,80.7,94.7,79.9z M84.2,87.8c-1.2,0-2.2-0.6-2.8-1.6h5.5C86.4,87.2,85.4,87.8,84.2,87.8z"
      />
    </g>
  </svg>
);
export const TotalSalesSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 75.9 67.7"
    style={{ width: "22px", height: "22px" }}
  >
    <path
      style={{ fill: "#9CA4AC" }}
      className="st0"
      d="M64.3,34.5l-52.2,0V15.6h10.3v7.7c0,1.2,0.9,2,2,2h1c1.1,0,2-0.9,2-2v-7.7H40v7.7c0,1.2,0.9,2,2,2h1  c1.1,0,2-0.9,2-2v-7.7h5.9c4.5,0,8.9,0,13.4,0V34.5z M33.3,6c-0.6,1.3-0.9,2.8-0.9,4.3v3.6h3v-3.6c0-1.4,0.4-2.7,1.1-3.8  C35.6,6.1,34.7,6,33.8,6C33.6,6,33.4,6,33.3,6z M24.5,24.3h1c0.6,0,1-0.5,1-1v-11c0-1.9,0.8-3.8,2.1-5.2C30,5.7,31.9,5,33.8,5  c1.9,0,3.8,0.8,5.2,2.1c1.4,1.4,2.1,3.2,2.1,5.2v11c0,0.6,0.5,1,1,1h1c0.6,0,1-0.5,1-1v-11c0-2.7-1.1-5.3-3-7.3  c-1.9-1.9-4.5-3-7.3-3c-2.7,0-5.3,1.1-7.3,3c-1.9,1.9-3,4.5-3,7.3v11C23.5,23.8,24,24.3,24.5,24.3z M42.6,3c1.9,0,3.8,0.8,5.2,2.1  c1.4,1.4,2.1,3.2,2.1,5.2v3.6h3v-3.6c0-2.7-1.1-5.3-3-7.3c-1.9-1.9-4.5-3-7.3-3c-1.9,0-3.8,0.5-5.4,1.5c1.2,0.4,2.3,1,3.4,1.7  C41.2,3.1,41.9,3,42.6,3z M60.6,57l-45.2,0l0,4.4h-3.2c0.2,3.5,3.2,6.2,6.7,6.2h32.1h6.7c3.5,0,6.4-2.8,6.7-6.2h-3.7L60.6,57z   M67.4,56.7l0-11.2h8.6l-3.5,6.7l3.5,7.3H62.6v-2.8H67.4z M13.3,59.4l0-2.8H8.6l0-11.2H0l3.5,6.7L0,59.4H13.3z M10.3,55l0-18.5  l55.4,0l0,18.5L10.3,55z"
    />
  </svg>
);

export const TotalIncomeSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 99.6 75.2"
    style={{ width: "22px", height: "22px" }}
  >
    <path
      style={{ fill: "#9CA4AC" }}
      className="st0"
      d="M0,68.1v-4.4h5.7H6v-45c0-3.5,2.9-6.4,6.4-6.4h23.4v8.8h-21v42.7h22.4v0.4c0,1.3,1.1,2.4,2.4,2.4h12.3  c1.3,0,2.4-1.1,2.4-2.4v-0.4h22.5v-18h8.8v17.9h0.3h5.7v4.4c0,3.9-3.2,7.1-7.1,7.1h-6.8H13.9H7.1C3.2,75.2,0,72,0,68.1z M99.6,5.9  v27.5c0,3.3-2.7,5.9-5.9,5.9H61.2L51.1,49.5c-0.5,0.5-1.5,0.2-1.5-0.6v-9.5h-1.3c-3.3,0-5.9-2.7-5.9-5.9V5.9c0-3.3,2.7-5.9,5.9-5.9  h45.4C96.9,0,99.6,2.6,99.6,5.9z M61.1,18.4c-1-0.5-2.1-0.9-3.1-1.4c-0.6-0.3-1.2-0.5-1.7-0.9c-1-0.8-0.8-2.1,0.3-2.6  c0.3-0.1,0.7-0.2,1-0.2c1.4-0.1,2.6,0.2,3.9,0.8c0.6,0.3,0.8,0.3,1-0.4c0.2-0.7,0.4-1.4,0.6-2c0.1-0.4-0.1-0.8-0.5-0.9  c-0.8-0.3-1.6-0.6-2.5-0.8C59,9.8,59,9.8,59,8.7c0-1.6,0-1.6-1.6-1.6c-0.3,0-0.4,0-0.7,0C56,7.2,55.9,7.3,55.9,8c0,0.3,0,0.7,0,1  c0,0.9,0,0.9-0.9,1.3c-2.3,0.8-3.7,2.5-3.9,4.9c-0.1,2.2,1,3.6,2.9,4.7c1.1,0.7,2.4,1.1,3.6,1.6c0.4,0.2,0.8,0.4,1.3,0.8  c1.2,0.9,0.9,2.5-0.4,3.1c-0.8,0.3-1.5,0.4-2.3,0.3c-1.2-0.2-2.4-0.4-3.5-1c-0.6-0.3-0.8-0.3-1,0.4c-0.2,0.6-0.3,1.2-0.5,1.8  c-0.3,0.8-0.2,1,0.6,1.4c1,0.5,2,0.8,3.1,0.9c0.8,0.1,0.8,0.2,0.8,1c0,0.4,0,0.8,0,1.2c0,0.4,0.3,0.8,0.8,0.8c0.6,0,1.2,0,1.8,0  c0.5,0,0.8-0.3,0.8-0.8s0-1.1,0-1.6s0.3-0.8,0.8-0.9c1.2-0.3,2.2-1,3.1-1.9C65,24.2,64.2,20.2,61.1,18.4z M91,26.5  c0-0.4-0.3-0.7-0.7-0.7H70.8c-0.4,0-0.7,0.3-0.7,0.7V29c0,0.4,0.3,0.7,0.7,0.7h19.4c0.4,0,0.7-0.3,0.7-0.7v-2.5H91z M91,18.4  c0-0.4-0.3-0.7-0.7-0.7H70.8c-0.4,0-0.7,0.3-0.7,0.7v2.5c0,0.4,0.3,0.7,0.7,0.7h19.4c0.4,0,0.7-0.3,0.7-0.7v-2.5H91z M91,10.2  c0-0.4-0.3-0.7-0.7-0.7H70.8c-0.4,0-0.7,0.3-0.7,0.7v2.5c0,0.4,0.3,0.7,0.7,0.7h19.4c0.4,0,0.7-0.3,0.7-0.7v-2.5H91z"
    />
  </svg>
);
export const TotalViewSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 36.7 31.1"
    style={{ width: "22px", height: "22px" }}
  >
    <path
      style={{ fill: "#9CA4AC" }}
      className="st0"
      d="M18.3,13C11.5,13,6,21.1,6,21.1s5.5,8.1,12.3,8.1s12.3-8.1,12.3-8.1S25.2,13,18.3,13z M18.3,27.1  c-3.3,0-6-2.7-6-6s2.7-6,6-6c3.3,0,6,2.7,6,6C24.3,24.4,21.6,27.1,18.3,27.1z M20.5,18.5c-0.6,0-1.1-0.5-1.1-1.1  c0-0.3,0.2-0.6,0.4-0.8c-0.5-0.2-1-0.3-1.5-0.3c-2.6,0-4.7,2.1-4.7,4.7s2.1,4.7,4.7,4.7c2.6,0,4.7-2.1,4.7-4.7  c0-1.3-0.6-2.5-1.5-3.4C21.4,18.2,21,18.5,20.5,18.5z M18.3,23.2c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2,2.1-2c1.1,0,2.1,0.9,2.1,2  C20.4,22.2,19.5,23.2,18.3,23.2z M34.4,0H2.3C1,0,0,1,0,2.3v26.6c0,1.3,1,2.3,2.3,2.3h1.3V8.3h29.6l0,22.8h1.3c1.3,0,2.3-1,2.3-2.3  V2.3C36.7,1,35.7,0,34.4,0z M5.7,6C4.8,6,4.1,5.3,4.1,4.4c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6C7.3,5.3,6.6,6,5.7,6z   M10.2,6C9.3,6,8.6,5.3,8.6,4.4c0-0.9,0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6C11.8,5.3,11.1,6,10.2,6z M14.6,6C13.7,6,13,5.3,13,4.4  c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6C16.2,5.3,15.5,6,14.6,6z M33.1,5.6H18.7V3.2h14.4V5.6z"
    />
  </svg>
);

export const ComapnySvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 980 811.9"
    style={{ width: "36px", height: "29px" }}
  >
    <path
      style={{ fill: "#0f6cac" }}
      d="M980,743.9c0,22.7,0,45.3,0,68c-326.7,0-653.3,0-980,0c0-22.7,0-45.3,0-68c22.4,0,44.8,0,67.7,0c0-3.1,0-5.4,0-7.8  c0-198.5,0-397,0.1-595.5c0-8.8,0.2-17.7,1.6-26.4C80.2,47.9,136,0.6,203.6,0.5c100.8-0.1,201.7-0.2,302.5,0.2  c12.7,0.1,25.7,1.7,37.9,5.1c59,16.6,97.9,68.8,98.1,130.8c0.2,65,0,130,0,195c0,2.1,0,4.2,0,6.6c2.8,0,4.8,0,6.7,0c42,0,84,0,126,0  c34.7,0,65.6,10.6,91.6,33.8c31.3,27.8,46.1,63.1,46.1,105c-0.1,86.5,0,173,0,259.5c0,2.3,0,4.6,0,7.5  C935.4,743.9,957.7,743.9,980,743.9z M574.5,743.8c0-2.7,0-5.1,0-7.4c0-117.3,0-234.6,0-351.9c0-82.2,0.1-164.3,0-246.5  c0-40.9-29.2-70-69.9-70c-99.8,0-199.6,0-299.4,0c-40.6,0-70,29.3-70,70c0,200.1,0,400.3,0,600.4c0,1.8,0,3.5,0,5.4  C281.8,743.8,427.7,743.8,574.5,743.8z M642.5,405.9c0,113,0,225.4,0,337.7c67.6,0,134.8,0,202.5,0c0-1.9,0-3.5,0-5.2  c0-87.6,0-175.3,0-262.9c0-40.4-29.3-69.6-69.7-69.6c-42.3,0-84.6,0-127,0C646.5,405.9,644.7,405.9,642.5,405.9z M337.6,439.4  c0-22.6,0-44.8,0-67c-45.1,0-89.8,0-134.6,0c0,22.5,0,44.6,0,67C248.4,439.4,293,439.4,337.6,439.4z M506.7,372.3  c-45,0-89.6,0-134.6,0c0,22.5,0,44.7,0,67.2c44.8,0,89.4,0,134.6,0C506.7,417,506.7,394.8,506.7,372.3z M203.2,575.2  c0,22.5,0,44.7,0,67c45,0,89.7,0,134.6,0c0-22.4,0-44.5,0-67C292.7,575.2,248,575.2,203.2,575.2z M372.2,642.1  c45.1,0,89.8,0,134.5,0c0-22.6,0-44.7,0-67c-44.9,0-89.5,0-134.5,0C372.2,597.7,372.2,620,372.2,642.1z M337.7,236.6  c0-22.4,0-44.5,0-66.8c-45,0-89.7,0-134.6,0c0,22.4,0,44.5,0,66.8C248.3,236.6,293,236.6,337.7,236.6z M506.6,236.6  c0-22.5,0-44.6,0-66.8c-45,0-89.7,0-134.6,0c0,22.4,0,44.5,0,66.8C417.3,236.6,462,236.6,506.6,236.6z M810.7,540.7  c0-22.5,0-44.5,0-66.8c-45,0-89.7,0-134.6,0c0,22.4,0,44.4,0,66.8C721.3,540.7,766,540.7,810.7,540.7z M676.1,609  c0,22.4,0,44.5,0,66.9c45,0,89.6,0,134.6,0c0-22.3,0-44.4,0-66.9C765.7,609,721,609,676.1,609z"
    />
  </svg>
);

export const ComapnyListSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 128 120"
    style={{ width: "26px", height: "24px" }}
  >
    <path
      style={{ fill: "#9CA4AC" }}
      d="M44.2,96.7l12.7,11.4L2.1,78.5c-0.3-0.2-0.6-0.3-0.8-0.6c-1.6-1.5-1.7-4-0.2-5.6l0,0l7.3-7.7l3,2.7L4,75h0L44.2,96.7z   M9,54.3L9,54.3l12.9-8.6l-2.1-3.4L6.8,51c-1.8,1.2-2.3,3.7-1.1,5.6c0.2,0.3,0.4,0.5,0.6,0.7l53.1,47.8l-7.9-12.5L9,54.3z   M63.9,97.2l3.3,12.7L15.6,28.4c-0.7-1.1-0.8-2.4-0.4-3.5c0.4-1.2,1.4-2.1,2.6-2.4l24.7-7.6l1,3.9L19,26.2L63.9,97.2z M19,26.2  l-0.6-1.9L19,26.2L19,26.2z M126.6,78.9L79.7,119c-0.7,0.6-1.7,1-2.6,1c-0.4,0-0.8-0.1-1.2-0.2c-1.3-0.4-2.3-1.5-2.7-2.8L44.1,5  c-0.3-1.3,0-2.6,0.8-3.6c0.9-1,2.1-1.5,3.4-1.4l70.2,6.6c1.9,0.2,3.5,1.7,3.6,3.6l5.8,65.3C128.1,76.8,127.6,78,126.6,78.9z   M64.9,25l44,2c0,0,0.1,0,0.1,0c1.1,0,1.9-0.8,2-1.9c0-1.1-0.8-2-1.9-2.1l-44-2c-1.1,0-2,0.8-2.1,1.9C63,24,63.8,24.9,64.9,25z   M111,39c1.1,0,1.9-0.8,2-1.9c0-1.1-0.8-2-1.9-2.1l-44-2c-1.1,0-2,0.8-2.1,1.9c0,0,0,0,0,0c-0.1,1.1,0.8,2,1.9,2.1L111,39  C110.9,39,111,39,111,39L111,39z"
    />
  </svg>
);

export const TravelersSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 60 48"
    style={{ width: "42px", height: "29px" }}
  >
    <path
      style={{ fill: "#0f6cac" }}
      d="M5,25c2.2,0,4-1.8,4-4s-1.8-4-4-4s-4,1.8-4,4C1,23.2,2.8,25,5,25z M5,19c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2 C3,19.9,3.9,19,5,19z M5,26c-1.4,0-2.8,0.6-3.7,1.7c-0.9,1-1.4,2.4-1.2,3.8l1.8,15.6c0.1,0.5,0.5,0.9,1,0.9H7c0.5,0,0.9-0.4,1-0.9 l2-15.6c0.2-1.4-0.3-2.8-1.2-3.9C7.8,26.6,6.4,26,5,26z M8,31.3L6.1,46H3.7L2,31.3c-0.1-0.8,0.2-1.6,0.7-2.3c1.1-1.2,3-1.3,4.3-0.2 c0.1,0.1,0.2,0.2,0.2,0.2C7.8,29.6,8.1,30.5,8,31.3z M51,25c2.2,0,4-1.8,4-4s-1.8-4-4-4s-4,1.8-4,4C47,23.2,48.8,25,51,25z M51,19 c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2s-2-0.9-2-2C49,19.9,49.9,19,51,19z M51.3,26c-2.5,0-4.7,1.8-5.1,4.3L44,46.9 c-0.1,0.5,0.3,1.1,0.9,1.1c0,0,0.1,0,0.1,0h14c0.6,0,1-0.4,1-1c0-0.1,0-0.1,0-0.2l-3.7-16.9C55.8,27.6,53.7,26,51.3,26z M46.1,46 l2.1-15.5c0.3-1.7,2-2.8,3.7-2.5c1.2,0.2,2.1,1.1,2.4,2.3L57.8,46H46.1z M38,12c3.3,0,6-2.7,6-6s-2.7-6-6-6s-6,2.7-6,6 C32,9.3,34.7,12,38,12z M38,2c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4C34,3.8,35.8,2,38,2z M44.3,16.8c-3.2-3.5-8.5-3.7-12-0.5 c-0.2,0.2-0.3,0.3-0.5,0.5c-1.3,1.5-2,3.4-1.7,5.4l3.1,25c0.1,0.5,0.5,0.9,1,0.9h7.3c0.5,0,0.9-0.4,1-0.9l3.5-24.9 C46.2,20.2,45.6,18.2,44.3,16.8z M44,22l-3.3,24H35l-3-24.1c-0.2-1.4,0.3-2.8,1.2-3.8c2.5-2.6,6.6-2.7,9.2-0.3 c0.1,0.1,0.2,0.2,0.3,0.3C43.7,19.1,44.1,20.5,44,22z M20,12c3.3,0,6-2.7,6-6s-2.7-6-6-6s-6,2.7-6,6C14,9.3,16.7,12,20,12z M20,2 c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4C16,3.8,17.8,2,20,2z M20,14c-3.5,0.1-6.5,2.8-6.8,6.3L10,46.9c-0.1,0.5,0.3,1,0.9,1.1 c0,0,0.1,0,0.1,0h20c0.6,0,1-0.4,1-1c0-0.1,0-0.1,0-0.2l-5.2-27C26.2,16.5,23.3,14.1,20,14z M12.1,46l3.1-25.5 c0.2-2.5,2.3-4.5,4.8-4.5c2.4,0.1,4.4,1.8,4.8,4.2l5,25.8H12.1z"
    />
  </svg>
);

export const NotificationsSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 77 85.6"
    style={{ width: "28px", height: "20px" }}
  >
    <path
      style={{ fill: "#3b3b3b" }}
      d="M74,66.4h-2.5V32.8C71.5,14.7,56.8,0,38.7,0S6,14.7,6,32.8c0,0,0,0,0,0v33.6H3c-1.7,0-3,1.3-3,3s1.3,3,3,3h23.6v1.4  c0.2,6.7,5.8,12,12.5,11.8c6.4-0.2,11.6-5.4,11.8-11.8v-1.4H74c1.7,0,3-1.3,3-3S75.7,66.4,74,66.4z M44.8,73.8c-0.1,3.4-3,6-6.4,5.9  c-3.2-0.1-5.7-2.7-5.9-5.9v-1.4h12.3V73.8z M65.5,49.3H11.9V32.8C11.9,18,23.9,6,38.7,6s26.8,12,26.8,26.8c0,0,0,0,0,0L65.5,49.3z"
    />
  </svg>
);

export const RiskAlertsSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 49 34.9"
    style={{ width: "28px", height: "20px" }}
  >
    <path
      style={{ fill: "#3b3b3b" }}
      d="M26,34.9l-26,0V8h49v15h-4V11.4l-41,0v19.4l22,0V34.9z M49,0v12H0V0H49z M8,4H4v4h4V4z M14,4h-4v4h4V4z M20,4h-4v4h4V4z   M48.2,34.9H37.7H27.2l5.2-9.3l5.3-9.3l5.3,9.2L48.2,34.9z M36.6,28.7c0,0.6,0.4,1,1,1c0.6,0,1-0.5,1-1v-7.2c0-0.6-0.4-1-1-1  c-0.6,0-1,0.5-1,1V28.7z M38.9,31.8c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1  C38.4,32.9,38.9,32.4,38.9,31.8z"
    />
  </svg>
);

export const GeofenceSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    focusable="false"
    x="0px"
    y="0px"
    viewBox="0 0 576 512"
    style={{ width: "36px", height: "29px" }}
  >
    <path
      style={{ fill: "#0f6cac" }}
      d="M560,32c-2,0-4,0.4-6,1.2L384,96h0L212,35.3c-6.5-2.2-13.4-3.3-20.2-3.3c-6.7,0-13.4,1-19.8,3.1L20.1,87.9
C8,92.8,0,104.6,0,117.7V464c0,9.2,7.5,16,16,16c2,0,4-0.4,6-1.2L192,416l172,60.7c13,4.3,27,4.4,40,0.1L555.9,424
c12.2-4.9,20.1-16.6,20.1-29.7V48C576,38.8,568.5,32,560,32z M224,90.4l128,45.2v286l-128-45.2V90.4z M48,418v-289l128-44.5v286.2
l-0.6,0.2L48,418z M528,382.9l-128,44.5V141.3l0.6-0.2L528,93.9V382.9z"
    />
  </svg>
);

export const FlightSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    focusable="false"
    x="0px"
    y="0px"
    viewBox="0 0 576 512"
    style={{ width: "28px", height: "20px" }}
  >
    <path
      style={{ fill: "#3b3b3b" }}
      d="M480,192H365.7L260.6,8.1c-2.9-5-8.2-8.1-13.9-8.1h-65.5c-10.6,0-18.3,10.2-15.4,20.4l49,171.6H112l-43.2-57.6
	c-3-4-7.8-6.4-12.8-6.4H16c-10.4,0-18,9.8-15.5,19.9L32,256L0.5,364.1C-2,374.2,5.6,384,16,384h40c5,0,9.8-2.4,12.8-6.4L112,320
	h102.9l-49,171.6c-2.9,10.2,4.8,20.4,15.4,20.4h65.5c5.7,0,11-3.1,13.9-8.1L365.7,320H480c35.3,0,96-28.6,96-64S515.3,192,480,192z"
    />
  </svg>
);

export const AlertsuserdashSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    focusable="false"
    x="0px"
    y="0px"
    viewBox="0 0 448 512"
    style={{ width: "28px", height: "20px" }}
  >
    <path
      style={{ fill: "#3b3b3b" }}
      d="M439.4,362.3c-19.3-20.8-55.5-52-55.5-154.3c0-77.7-54.5-139.9-127.9-155.2V32c0-17.7-14.3-32-32-32s-32,14.3-32,32v20.8
	C118.6,68.1,64.1,130.3,64.1,208c0,102.3-36.2,133.5-55.5,154.3C2.6,368.7,0,376.4,0,384c0.1,16.4,13,32,32.1,32h383.8
	c19.1,0,32-15.6,32.1-32C448,376.4,445.4,368.7,439.4,362.3L439.4,362.3z M67.5,368c21.2-28,44.4-74.3,44.5-159.4
	c0-0.2-0.1-0.4-0.1-0.6c0-61.9,50.1-112,112-112s112,50.1,112,112c0,0.2-0.1,0.4-0.1,0.6C336,293.7,359.3,340,380.5,368H67.5z
	 M224,512c35.3,0,64-28.6,64-64H160C160,483.4,188.7,512,224,512z"
    />
  </svg>
);
export const HotelsuserdashSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    focusable="false"
    x="0px"
    y="0px"
    viewBox="0 0 576 512"
    style={{ width: "28px", height: "20px" }}
  >
    <path
      style={{ fill: "#3b3b3b" }}
      d="M560,64c8.8,0,16-7.2,16-16V16c0-8.8-7.2-16-16-16H16C7.2,0,0,7.2,0,16v32c0,8.8,7.2,16,16,16h16v384H16
	c-8.8,0-16,7.2-16,16v32c0,8.8,7.2,16,16,16h240v-80c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16v80h240c8.8,0,16-7.2,16-16v-32
	c0-8.8-7.2-16-16-16h-16V64H560z M256,108.8c0-6.4,6.4-12.8,12.8-12.8h38.4c6.4,0,12.8,6.4,12.8,12.8v38.4c0,6.4-6.4,12.8-12.8,12.8
	h-38.4c-6.4,0-12.8-6.4-12.8-12.8L256,108.8L256,108.8z M256,204.8c0-6.4,6.4-12.8,12.8-12.8h38.4c6.4,0,12.8,6.4,12.8,12.8v38.4
	c0,6.4-6.4,12.8-12.8,12.8h-38.4c-6.4,0-12.8-6.4-12.8-12.8L256,204.8L256,204.8z M128,108.8c0-6.4,6.4-12.8,12.8-12.8h38.4
	c6.4,0,12.8,6.4,12.8,12.8v38.4c0,6.4-6.4,12.8-12.8,12.8h-38.4c-6.4,0-12.8-6.4-12.8-12.8L128,108.8L128,108.8z M179.2,256h-38.4
	c-6.4,0-12.8-6.4-12.8-12.8v-38.4c0-6.4,6.4-12.8,12.8-12.8h38.4c6.4,0,12.8,6.4,12.8,12.8v38.4C192,249.6,185.6,256,179.2,256
	L179.2,256z M192,384c0-53,43-96,96-96s96,43,96,96H192z M448,243.2c0,6.4-6.4,12.8-12.8,12.8h-38.4c-6.4,0-12.8-6.4-12.8-12.8
	v-38.4c0-6.4,6.4-12.8,12.8-12.8h38.4c6.4,0,12.8,6.4,12.8,12.8V243.2L448,243.2z M448,147.2c0,6.4-6.4,12.8-12.8,12.8h-38.4
	c-6.4,0-12.8-6.4-12.8-12.8v-38.4c0-6.4,6.4-12.8,12.8-12.8h38.4c6.4,0,12.8,6.4,12.8,12.8V147.2z"
    />
  </svg>
);
export const CarrentalsSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    focusable="false"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style={{ width: "28px", height: "20px" }}
  >
    <path
      style={{ fill: "#3b3b3b" }}
      d="M500,176h-59.9l-16.6-41.6C406.4,91.6,365.6,64,319.5,64h-127c-46.1,0-86.9,27.6-104,70.4L71.9,176H12
	c-7.8,0-13.5,7.3-11.6,14.9l6,24c1.3,5.3,6.1,9.1,11.6,9.1h20.1C24.6,235.7,16,252.8,16,272v48c0,16.1,6.2,30.7,16,41.9V416
	c0,17.7,14.3,32,32,32h32c17.7,0,32-14.3,32-32v-32h256v32c0,17.7,14.3,32,32,32h32c17.7,0,32-14.3,32-32v-54.1
	c9.8-11.3,16-25.8,16-41.9v-48c0-19.2-8.6-36.3-22.1-48H494c5.5,0,10.3-3.8,11.6-9.1l6-24C513.5,183.3,507.8,176,500,176L500,176z
	 M147.9,158.2c7.3-18.2,24.9-30.2,44.6-30.2h127c19.6,0,37.3,11.9,44.6,30.2L384,208H128L147.9,158.2z M96,319.8
	c-19.2,0-32-12.8-32-31.9S76.8,256,96,256s48,28.7,48,47.9S115.2,319.8,96,319.8L96,319.8z M416,319.8c-19.2,0-48,3.2-48-16
	s28.8-47.8,48-47.8s32,12.8,32,31.9S435.2,319.8,416,319.8z"
    />
  </svg>
);
export const PushnotificationSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    focusable="false"
    x="0px"
    y="0px"
    viewBox="0 0 448 512"
    style={{ width: "28px", height: "20px" }}
  >
    <path
      style={{ fill: "#3b3b3b" }}
      d="M439.4,362.3c-19.3-20.8-55.5-52-55.5-154.3c0-77.7-54.5-139.9-127.9-155.2V32c0-17.7-14.3-32-32-32s-32,14.3-32,32v20.8
	C118.6,68.1,64.1,130.3,64.1,208c0,102.3-36.2,133.5-55.5,154.3C2.6,368.7,0,376.4,0,384c0.1,16.4,13,32,32.1,32h383.8
	c19.1,0,32-15.6,32.1-32C448,376.4,445.4,368.7,439.4,362.3L439.4,362.3z M67.5,368c21.2-28,44.4-74.3,44.5-159.4
	c0-0.2-0.1-0.4-0.1-0.6c0-61.9,50.1-112,112-112s112,50.1,112,112c0,0.2-0.1,0.4-0.1,0.6C336,293.7,359.3,340,380.5,368H67.5z
	 M224,512c35.3,0,64-28.6,64-64H160C160,483.4,188.7,512,224,512z"
    />
  </svg>
);
export const EmailnotificationSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    focusable="false"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style={{ width: "28px", height: "20px" }}
  >
    <path
      style={{ fill: "#3b3b3b" }}
      d="M464,64H48C21.5,64,0,85.5,0,112v288c0,26.5,21.5,48,48,48h416c26.5,0,48-21.5,48-48V112C512,85.5,490.5,64,464,64z
	 M464,112v40.8c-22.4,18.3-58.2,46.7-134.6,106.5c-16.8,13.2-50.2,45.1-73.4,44.7c-23.2,0.4-56.6-31.5-73.4-44.7
	C106.2,199.5,70.4,171.1,48,152.8V112H464z M48,400V214.4c22.9,18.3,55.4,43.9,104.9,82.6c21.9,17.2,60.1,55.2,103.1,55
	c42.7,0.2,80.5-37.2,103.1-54.9c49.5-38.8,82-64.4,104.9-82.7V400H48z"
    />
  </svg>
);
export const SmsnotificationSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    focusable="false"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style={{ width: "28px", height: "20px" }}
  >
    <path
      style={{ fill: "#3b3b3b" }}
      d="M256,32C114.6,32,0,125.1,0,240c0,49.6,21.4,95,57,130.7C44.5,421.1,2.7,466,2.2,466.5c-2.2,2.3-2.8,5.7-1.5,8.7
	S4.8,480,8,480c66.3,0,116-31.8,140.6-51.4c32.7,12.3,69,19.4,107.4,19.4c141.4,0,256-93.1,256-208S397.4,32,256,32z M128.2,304H116
	c-4.4,0-8-3.6-8-8v-16c0-4.4,3.6-8,8-8h12.3c6,0,10.4-3.5,10.4-6.6c0-1.3-0.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1
	c0-21.3,19-38.6,42.4-38.6H156c4.4,0,8,3.6,8,8v16c0,4.4-3.6,8-8,8h-12.3c-6,0-10.4,3.5-10.4,6.6c0,1.3,0.8,2.7,2.1,3.8l21.9,18.8
	c8.5,7.2,13.3,17.5,13.3,28.1C170.7,286.7,151.6,304,128.2,304L128.2,304z M320,296c0,4.4-3.6,8-8,8h-16c-4.4,0-8-3.6-8-8v-68.2
	l-24.8,55.8c-2.9,5.9-11.4,5.9-14.3,0L224,227.8V296c0,4.4-3.6,8-8,8h-16c-4.4,0-8-3.6-8-8V192c0-8.8,7.2-16,16-16h16
	c6.1,0,11.6,3.4,14.3,8.8l17.7,35.4l17.7-35.4c2.7-5.4,8.3-8.8,14.3-8.8h16c8.8,0,16,7.2,16,16V296z M368.3,304H356
	c-4.4,0-8-3.6-8-8v-16c0-4.4,3.6-8,8-8h12.3c6,0,10.4-3.5,10.4-6.6c0-1.3-0.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1
	c0-21.3,19-38.6,42.4-38.6H396c4.4,0,8,3.6,8,8v16c0,4.4-3.6,8-8,8h-12.3c-6,0-10.4,3.5-10.4,6.6c0,1.3,0.8,2.7,2.1,3.8l21.9,18.8
	c8.5,7.2,13.3,17.5,13.3,28.1C410.7,286.7,391.7,304,368.3,304L368.3,304z"
    />
  </svg>
);
export const NotificationadmindashSvg = () => (
  <svg
    version="1.1"
    id="Layer_1"
    focusable="false"
    x="0px"
    y="0px"
    viewBox="0 0 576 512"
    style={{ width: "28px", height: "20px" }}
  >
    <path
      style={{ fill: "#3b3b3b" }}
      d="M576,240c0-23.6-13-44-32-55.1V32c0-8.7-7-32-32-32c-7.1,0-14.2,2.4-20,7l-85,68c-42.7,34.1-96.3,53-151,53H64
	c-35.3,0-64,28.6-64,64v96c0,35.4,28.6,64,64,64h33.7c-1.4,10.5-2.2,21.1-2.2,32c0,39.8,9.3,77.4,25.6,110.9
	c5.2,10.7,16.5,17.1,28.4,17.1h74.3c26.1,0,41.7-29.8,25.9-50.6c-16.4-21.5-26.1-48.4-26.1-77.4c0-11.1,1.6-21.8,4.4-32H256
	c54.7,0,108.3,18.8,151,53l85,68c5.7,4.5,12.7,7,20,7c24.9,0,32-22.8,32-32V295.1C563,284,576,263.6,576,240z M480,381.4L447,355
	c-54-43.2-121.8-67-191-67v-96c69.1,0,137-23.8,191-67l33-26.4V381.4z"
    />
  </svg>
);
export const NAVSvg = () => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 width="100px" height="100px" viewBox="0 0 100 100" enable-background="new 0 0 100 100">
    <path fill="#FFFFFF" d="M48.2,8c-1-0.1-1.9,0.5-2.2,1.5C45.9,10,33.7,58,4.9,78.4C4.3,78.7,4,79.4,4,80v6c0,0.8,0.5,1.5,1.2,1.8
      C5.4,87.9,5.7,88,6,88c0.5,0,1-0.2,1.3-0.5C24.5,72.3,48.3,66,48.5,65.9c0.9-0.2,1.5-1,1.5-1.9V10C50,9,49.3,8.1,48.2,8z M72.3,20
      c-1-0.2-1.9,0.4-2.2,1.3c0,0.1-3.6,10.4-16.1,23.6v19c0,2.7-1.9,5.1-4.5,5.8c-0.2,0-11.9,3.2-24.6,10.3c22.3-6.7,46.7-6.1,47-6.1
      c0.5,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.4V22C74,21,73.3,20.2,72.3,20z M94.1,34c-0.6,0-1.2,0.3-1.6,0.7
      c-4.2,5.2-9,10.1-14.4,14.6V72c0,1.6-0.7,3.2-1.8,4.3C75.1,77.4,73.6,78,72,78h-0.2c-0.1,0-0.8,0-1.9,0c-6.5,0-40.1,0.6-60.8,13.2
      c-0.2,0.1-0.4,0.2-0.6,0.3C14.4,90,32.7,86,52,86c23.2,0,41.2,5.8,41.4,5.9c0.6,0.2,1.3,0.1,1.8-0.3c0.5-0.4,0.8-1,0.8-1.6V36
      c0-0.9-0.5-1.6-1.3-1.9C94.5,34,94.3,34,94.1,34z"/>
  </svg>
);
export const B2B2CSvg = () => (
  <svg enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path fill="#ffffff" d="m183.272 209.548h73.017 73.017c7.931 0 14.354-6.449 14.354-14.413v-15.707c0-41.193-32.713-76.769-77.285-76.769 23.539-4.706 41.286-25.557 41.286-50.584 0-28.485-23.004-51.574-51.372-51.574s-51.372 23.089-51.372 51.574c0 25.027 17.747 45.878 41.286 50.584-44.514 0-77.285 35.521-77.285 76.769v15.707c.001 7.963 6.423 14.413 14.354 14.413z"/>
      <path fill="#ffffff" d="m64.518 249.767c.908.166 1.809.246 2.7.246 7.1 0 13.407-5.09 14.724-12.354 3.689-20.354 10.673-40.131 20.757-58.78 9.732-17.997 21.936-34.159 36.273-48.036 5.958-5.766 6.132-15.291.389-21.274-5.743-5.982-15.228-6.157-21.186-.391-16.547 16.017-30.615 34.637-41.811 55.343-11.603 21.458-19.646 44.252-23.905 67.75-1.481 8.175 3.918 16.008 12.059 17.496z"/>
      <path fill="#ffffff" d="m409.88 178.878c10.084 18.65 17.068 38.426 20.757 58.78 1.317 7.265 7.623 12.354 14.724 12.354.89 0 1.793-.08 2.7-.246 8.141-1.488 13.54-9.321 12.058-17.496-4.259-23.498-12.302-46.293-23.905-67.75-11.196-20.706-25.264-39.327-41.811-55.343-5.958-5.767-15.443-5.591-21.186.391-5.743 5.983-5.568 15.507.389 21.274 14.338 13.877 26.542 30.039 36.274 48.036z"/>
      <path fill="#ffffff" d="m316.821 364.681c-19.328 6.379-39.685 9.649-60.531 9.719-.27.01-.549.01-.819.01-20.387 0-40.364-3.059-59.353-9.087-7.891-2.508-16.302 1.885-18.799 9.809s1.878 16.369 9.769 18.876c21.915 6.961 44.919 10.491 68.383 10.491h.819c24.033-.09 47.536-3.862 69.881-11.234 7.861-2.588 12.146-11.093 9.559-18.987-2.577-7.892-11.048-12.195-18.909-9.597z"/>
      <path fill="#ffffff" d="m97.455 404.61c23.54-4.707 41.288-25.565 41.288-50.584 0-28.485-23.004-51.584-51.372-51.584s-51.372 23.099-51.372 51.584c0 25.019 17.748 45.877 41.288 50.584-44.476 0-77.287 35.485-77.287 76.77v15.707c0 7.954 6.423 14.413 14.354 14.413h73.017 73.017c7.931 0 14.354-6.459 14.354-14.413v-15.707c0-41.111-32.624-76.77-77.287-76.77z"/>
      <path fill="#ffffff" d="m434.713 404.61c23.54-4.707 41.288-25.565 41.288-50.584 0-28.485-23.004-51.584-51.372-51.584-28.378 0-51.372 23.099-51.372 51.584 0 25.019 17.741 45.877 41.285 50.584-44.578 0-77.285 35.568-77.285 76.769v15.707c0 7.954 6.423 14.413 14.354 14.413h73.017 73.017c7.921 0 14.354-6.459 14.354-14.413v-15.706c.001-41.197-32.714-76.77-77.286-76.77z"/>
    </g>
  </svg>
);
